import { jsx as _jsx } from "react/jsx-runtime";
import { CircularLoader } from 'seagull';
import { RichTextViewer } from 'seagull/components/RichTextViewer';
import { getTestIds } from 'seagull/utils/TestIds';
import { toParsedRichText } from '~/components/LegalTermsDropdown/hooks/toParsedRichText';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import styles from './QuillViewerWithFetch.module.scss';
export const QuillViewerWithFetchTestIds = getTestIds('QuillViewerWithFetchTestIds');
export function QuillViewerWithFetch(param) {
    let { fetchContent, queryKey } = param;
    const { data: content, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.RichText,
            queryKey
        ],
        queryFn: ()=>fetchContent === null || fetchContent === void 0 ? void 0 : fetchContent(),
        enabled: !!fetchContent
    });
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            "data-testid": QuillViewerWithFetchTestIds.Loader(),
            style: {
                position: 'absolute',
                top: 'calc(50% - 16px)',
                left: 'calc(50% - 16px)'
            },
            children: /*#__PURE__*/ _jsx(CircularLoader, {
                size: 32
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.container,
        "data-testid": QuillViewerWithFetchTestIds.Container(),
        children: /*#__PURE__*/ _jsx(RichTextViewer, {
            value: toParsedRichText(content !== null && content !== void 0 ? content : [])
        })
    });
}
